import React from 'react'
import {graphql} from 'gatsby'
import Container from '../components/container'
import GraphQLErrorList from '../components/graphql-error-list'
import SEO from '../components/seo'
import Layout from '../containers/layout'
import ArticlePreviewGrid from '../components/ArticlePreview/ArticlePreviewGrid'
import {filterOutDocsWithoutSlugs, filterOutDocsPublishedInTheFuture} from '../lib/helpers'

export const query = graphql`
  query IndexPageQuery {
    site: sanitySiteSettings(_id: {regex: "/(drafts.|)siteSettings/"}) {
      title
      description
      keywords
    }
    page: sanityFrontPage(_id: {regex: "/(drafts.|)frontPage/"}) {
      articles {
        id
        mainImage {
          crop {
            _key
            _type
            top
            bottom
            left
            right
          }
          hotspot {
            _key
            _type
            x
            y
            height
            width
          }
          asset {
            _id
          }
          alt
        }
        title
        _rawExcerpt
        slug {
          current
        }
        authors {
          _key
          person {
            name
            slug {
              current
            }
          }
          contributedWith
        }
      }
    }
  }
`

const IndexPage = props => {
  const {data, errors} = props

  if (errors) {
    return (
      <Layout>
        <GraphQLErrorList errors={errors} />
      </Layout>
    )
  }

  const site = (data && data.site) || {}
  const articles = (data && data.page && data.page.articles).filter(filterOutDocsWithoutSlugs).filter(filterOutDocsPublishedInTheFuture) || []

  if (!site) {
    throw new Error(
      'Missing "Site settings". Open the studio at http://localhost:3333 and add some content to "Site settings" and restart the development server.'
    )
  }

  return (
    <Layout>
      <SEO title={site.title} description={site.description} keywords={site.keywords} />
      <Container>
        <h1 hidden>Welcome to {site.title}</h1>
        {articles && <ArticlePreviewGrid nodes={articles} browseMoreHref='/mer/' />}
      </Container>
    </Layout>
  )
}

export default IndexPage
